import { Support } from "../components/sections/Support";
import { StandaloneSection } from "./StandaloneSection";

export default function SupportPage() {
    return (
        <StandaloneSection>
            <Support />
        </StandaloneSection>
    );
}
